import { InsuranceMonitor } from "@wingspanhq/wingspan-api-sdk";

export const getInsuranceCoverageRequirementName = (
  insuranceMonitor: InsuranceMonitor | undefined,
  defaultName: string
): string => {
  if (!insuranceMonitor) {
    return defaultName || "Insurance Coverage";
  }

  return defaultName;
};
